//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const sports = require('~/data/sports.json')

export default {
  /*beforeRouteEnter(to, from, next) {
    if (!_.includes(sports, _.get(to, 'params.sport'))) {
      next(false)
    } else {
      next()
    }
  },*/
  data() {
    return {
      breadcrumbs: null,
      crumbs: [],
      competition: null,
      loading: true,
      outright: null
    }
  },
  computed: {
    sports() {
      return this.$store.state.sports
    },    
    sport() {
      return _.find(this.$store.state.sports, {'provider_id': parseInt(this.$route.query.sportId)})
    },
  },
  mounted() {
    this.fetchEvents()
    // this.fetchInfo()
  },
    async fetch() {
    //let's get the breadcrumb title
      try {
        let params = this.$route.params;
        params['lang'] = this.lang;
        const response = await this.$content().get('breadcrumbs', { params: params })
        this.breadcrumbs = _.get(response.data, 'data.competition.name')
        if(!_.get(response.data, 'data.sport')) {
          return this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
        }
        this.crumbs = [
          {'name' : _.get(response.data.data, 'sport.name'), 'url': this.localePath('/' + _.get(response.data.data, 'sport.translated_slug')) },
        ]

        await this.fetchInfo()

        this.$store.commit('seo/setVariables', {
          sport: _.get(response.data.data, 'sport.name'),
          region: _.get(response.data.data, 'region.name'),
          competition: _.get(response.data.data, 'competition.name'),
          event: _.get(this.outright, 'name'),
        });
      } catch (e) {
        console.log(e.message);
      }
  },
  methods: {
    getURL: function (competition, mode) {
      if (mode == 'outrights') {
        return this.localePath({ name: 'sport-competition-outrights', params: { competition: competition.slug } })
      }
      return this.localePath({ name: 'sport-competition', params: { competition: competition.slug } })
    },
    async fetchInfo() {
        let params = this.$route.params;
        params['lang'] = this.lang;
        params['bookmaker'] = process.env.BOOKMAKER;
        const response = await this.$infoapi().get('v1/info/competition', { params: params })
        // console.log('fetchInfo', response);
        if(_.get(response, 'data.competition.count') > 0) {
          this.competition = _.get(response, 'data.competition');
        }       
      this.outright = _.get(response, 'data.outright');
  
    },
    async fetchEvents() {
      this.loading = true
// console.log('competitions',  this.$route.query.competitionId);
     /* this.$socket().send('get', 'competitions', this.$route.query.competitionId, { fetch: 'all' }, (error, response) => {
        console.log(error, response);
        this.competition = response.competition
        this.loading = false
      })
      */
      this.loading = false
    }
  }
}
